import React from "react";
import OtpVerification from "../components/auth/otpVerification";

const EmailVerification = () => {
  return <OtpVerification />;
};

export default EmailVerification;
